module.exports = __webpack_public_path__ + "assets/asset_factory.cbac4af3.svg";